// extracted by mini-css-extract-plugin
export default {"scrollTop":"ScrollTop_scrollTop__Ww9NY","iconposition":"ScrollTop_iconposition__FIrfY","iconstyle":"ScrollTop_iconstyle__oc7k6","movebtn":"ScrollTop_movebtn__Z0drn"};